import Vue from 'vue';
import Vuex from 'vuex';
import utils from '../config/utils';
import actions from './actions';
import mutations from './mutations';

// 获取本地state
const getState = function (name, value) {
  value = typeof value === 'undefined' ? null : value;
  return JSON.parse(localStorage.getItem(name)) || value;
};

const getSessionState = function (name, value) {
  value = typeof value === 'undefined' ? null : value;
  return JSON.parse(sessionStorage.getItem(name)) || value;
};

Vue.use(Vuex);

const state = {
  token: utils.getCookie('token') || '', // 权限Token
  baseInfo: getState('baseInfo'), // 基本信息
  redirectUrl: getState('redirectUrl'), // 重定向路由路径信息
  cartData: getState('cartData'),
  baseInfoMobile: getState('baseInfoMobile')
};

const sessionState = {
  location: getSessionState('location'),
};

const gentters = {};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  gentters,
  sessionState,
});



// WEBPACK FOOTER //
// ./src/store/index.js